module.exports = __webpack_public_path__ + "img/release-characters-gold.90062ba9.png";